import { render, staticRenderFns } from "./loaderCarga.vue?vue&type=template&id=61a9b376&scoped=true"
import script from "./loaderCarga.vue?vue&type=script&lang=js"
export * from "./loaderCarga.vue?vue&type=script&lang=js"
import style0 from "./loaderCarga.vue?vue&type=style&index=0&id=61a9b376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9b376",
  null
  
)

export default component.exports